import { ref, computed } from 'vue';

// Singleton pattern for Strapi URL management
let strapiUrlInstance = null;

export function useStrapiUrl() {
  if (!strapiUrlInstance) {
    const configUrl = window?.AppConfig?.strapiUrl;
    const fallbackUrl = 'https://cms.brochure.urencoisotopes.com';
    // Temporary override: Force production URL if localhost is detected
    const finalUrl = (configUrl && configUrl.includes('localhost')) ? fallbackUrl : configUrl;
    const baseUrl = ref(finalUrl);

    const getStrapiUrl = (path) => {
      if (!path) return baseUrl.value;
      return baseUrl.value + (path.startsWith('/') ? path : `/${path}`);
    };

    strapiUrlInstance = {
      baseUrl: computed(() => baseUrl.value),
      getStrapiUrl
    };
  }

  return strapiUrlInstance;
}
